import React from 'react'
import PropTypes from 'prop-types'

const StarsReview = ({ number }) => (
  <div className="stars-review">
    {
      [...Array(3)].map((item, index) => (
        index < number ?
          <img key={index} src="/assets/images/star.png" alt="star" />
        :
          <img key={index} src="/assets/images/star-empty.png" alt="star" />
      ))
    }
  </div>
)

StarsReview.defaultProps = {
  number: 1,
}

StarsReview.propTypes = {
  number: PropTypes.number,
}

export default StarsReview



// WEBPACK FOOTER //
// ./src/browser/components/StarsReview.js